import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { initMercadoPago, Wallet } from '@mercadopago/sdk-react'
initMercadoPago('APP_USR-6bb74cef-659e-418b-8857-0acf5e2223bc');



const MercadoPago: React.FC = () => {
    const { preferenceId } = useParams<{ preferenceId: string }>();
    if (!preferenceId) {
        return <div>Preference ID is required</div>;
    }
    return (

    <Wallet initialization={{ preferenceId: preferenceId }} customization={{ texts:{ valueProp: 'smart_option'}}} />
    )
}

export default MercadoPago;

